<template>
	<v-container grid-list-md>
		<h3>{{ $__("Edit Catalogue") }}</h3>
		<div class="mb-2 mt-1">
			<CatalogueStepper :value="1"></CatalogueStepper>
		</div>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-text>
						<ShopFormCatalogue
							v-model="item"
							:outlets="outlets"
						></ShopFormCatalogue>
						<v-btn
							color="primary"
							@click.native="submit()"
							:loading="item.processing"
							:disabled="invalid"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Save") }}
						</v-btn>
					</v-card-text>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-container>
</template>

<script>
import CatalogueStepper from "@Shop/components/CatalogueStepper.vue";
import ShopFormCatalogue from "@Shop/forms/ShopFormCatalogue.vue";
export default {
	components: {
		ShopFormCatalogue,
		CatalogueStepper,
	},

	props: [
		"catalogue",
		"outlets",
		"catalogue_categories",
		"available_categories",
		"catalogue_products",
	],

	data() {
		return {
			stepper: this.$route().params.currentStep ?? 2,
			item: this.$inertia.form(this.catalogue),
		};
	},

	methods: {
		submit() {
			this.item.put(
				this.$route("tenant.catalogues.update", {
					tenant: this.$page.props.tenant.id,
					catalogue: this.catalogue.uuid,
				})
			);
		},
		addCategory() {
			this.$inertia.reload({ only: ["available_categories"] });
			this.$refs.catalogueCategoriesComponent.categoryDialog = true;
		},
	},
};
</script>